var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"af408adf561290d99e82cf85fb466faf9dbc506b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["scholar-production@leap-scholar"]={id:"af408adf561290d99e82cf85fb466faf9dbc506b"};
      